import { render, staticRenderFns } from "./AnnouncementDisplay.vue?vue&type=template&id=8b4f011c&scoped=true"
import script from "./AnnouncementDisplay.vue?vue&type=script&lang=js"
export * from "./AnnouncementDisplay.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementDisplay.vue?vue&type=style&index=0&id=8b4f011c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4f011c",
  null
  
)

export default component.exports